import { render, staticRenderFns } from "./DemoTimePickerUseSeconds.vue?vue&type=template&id=56b2c2bc&"
import script from "./DemoTimePickerUseSeconds.vue?vue&type=script&lang=js&"
export * from "./DemoTimePickerUseSeconds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTimePicker } from 'vuetify/lib/components/VTimePicker';
installComponents(component, {VTimePicker})
